var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpaceRental(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2742_29859)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3251 3.125H24.0751C24.0751 2.85051 23.9251 2.59796 23.6842 2.46654C23.4432 2.33513 23.1497 2.34586 22.9189 2.49451L23.3251 3.125ZM23.3251 22.8438V23.5938H24.0751V22.8438H23.3251ZM1.67969 22.8438H0.929688V23.5938H1.67969V22.8438ZM1.67969 3.125L2.08587 2.49451C1.85512 2.34586 1.5616 2.33513 1.32061 2.46654C1.07963 2.59796 0.929688 2.85051 0.929688 3.125H1.67969ZM22.5751 3.125V22.8438H24.0751V3.125H22.5751ZM23.3251 22.0938H1.67969V23.5938H23.3251V22.0938ZM2.42969 22.8438V3.125H0.929688V22.8438H2.42969ZM22.9189 2.49451L17.7069 5.85221L18.5193 7.11319L23.7313 3.75549L22.9189 2.49451ZM1.27351 3.75549L6.48551 7.11319L7.29786 5.85221L2.08587 2.49451L1.27351 3.75549Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.85938,
    y: 6.11559,
    width: 11.284,
    height: 11.284,
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.64844 22.7439L6.89189 17.5004",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9204 22.3444L17.9766 17.4005",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5625 20.0128H20.375",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 0V4.25",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16.5007,
    cy: 6.30009,
    r: 3.32491,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2742_29859"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceRental);
export default __webpack_public_path__ + "static/media/space-rental.16c2071d85a3c4cf000c049caa20441e.svg";
export { ForwardRef as ReactComponent };